// External
import React from "react";
import { useI18n } from "Hooks";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";

// Design System
import { Tooltip } from "@toddle-edu/ds-web";

// Styles
import classes from "./MoreItemWithToolTipV2.scss";

// Utils
import { onEnterOrSpaceKeyDown } from "Utils";

const MoreItemWithToolTipV2 = props => {
  const {
    items,
    length,
    noItemText,
    moreJoinSymbol,
    customClass,
    color,
    moreItemCustomClass,
    toolTipItemTextClass,
    customContainerClass,
    tooltipOverlayStyle,
    trigger,
  } = props;

  const { t } = useI18n();

  if (_.isEmpty(items)) {
    return <div className={"text-body text-disabled"}>{noItemText}</div>;
  }

  const visibleItems = _.slice(items, 0, length);
  const remainingItemsCount = _.size(items) - length;

  const tooltipContent = (
    <div>
      {_.map(items, (item, index) => (
        <div className={toolTipItemTextClass} key={index}>
          {item}
        </div>
      ))}
    </div>
  );

  const moreItemsTextClasses = classNames(
    classes.textColorInfo,
    classes.moreItemsText,
    moreItemCustomClass
  );

  const handleClick = e => {
    e.stopPropagation();
  };

  const handleKeyDown = e => {
    onEnterOrSpaceKeyDown(e, handleClick);
  };

  return (
    <div className={classNames(classes.container, customContainerClass)}>
      {_.map(visibleItems, (item, index) => (
        <span
          key={index}
          className={customClass}
          style={color ? { color } : {}}
          dir="auto"
        >
          {item}
          {index < _.size(visibleItems) - 1 ? "," : ""}
        </span>
      ))}
      {remainingItemsCount > 0 ? (
        <Tooltip
          tooltip={tooltipContent}
          trigger={trigger}
          placement={"right"}
          showArrow={"true"}
          overlayStyle={tooltipOverlayStyle}
        >
          <span
            className={moreItemsTextClasses}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
          >
            {t("common:number_more", {
              number: `${moreJoinSymbol}${remainingItemsCount}`,
            })}
          </span>
        </Tooltip>
      ) : null}
    </div>
  );
};

MoreItemWithToolTipV2.defaultProps = {
  items: [],
  length: 0,
  noItemText: "",
  moreJoinSymbol: " +",
  customClass: "text-body truncate",
  moreItemCustomClass: "",
  trigger: ["focus", "click"],
};

MoreItemWithToolTipV2.propTypes = {
  items: PropTypes.array,
  length: PropTypes.number,
  noItemText: PropTypes.string,
  moreJoinSymbol: PropTypes.string,
  customClass: PropTypes.string,
  color: PropTypes.string,
  moreItemCustomClass: PropTypes.string,
  tooltipOverlayStyle: PropTypes.object,
};

export default MoreItemWithToolTipV2;
